import { BackgroundCheckConfig } from '@/backend/features/background-check/defaults';

export function getEnabledBackgroundCheckTypes(backgroundCheckTypesSetting: BackgroundCheckConfig['type']) {
    return Object.entries(backgroundCheckTypesSetting)
        .filter(([, config]) => config.enabled)
        .map(([backgroundCheckType, config]) => {
            return {
                value: backgroundCheckType,
                label: config.label,
            };
        });
}
